import { render } from "./MatchScore.vue?vue&type=template&id=11082404&scoped=true"
import script from "./MatchScore.vue?vue&type=script&lang=js"
export * from "./MatchScore.vue?vue&type=script&lang=js"

import "./MatchScore.vue?vue&type=style&index=0&id=11082404&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11082404"]])

export default __exports__